// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import ReferenceDatesWearView from "../../components/wearReferenceDates";

const ReferenceDatesWear = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <ReferenceDatesWearView />
    </Main>
  </>
);

export default ReferenceDatesWear;
